import styled, { css, DefaultTheme } from 'styled-components';

export default styled.div`
  ${({ theme }: { theme: DefaultTheme }) => {
    return css`
      display: flex;
      align-items: center;
      pointer-events: all;
      margin: 0;
      @media ${theme.mq.min.tablet} {
        width: 3.25em;
        height: fit-content;
      }
      .toolbar {
        background-color: var(--primary-color);
        border-radius: 0.375em;
        border: 1px solid rgba(255, 255, 255, 0.12);
        position: absolute;
        padding: 0.25em;
        transform: rotate(180deg);
        @media ${theme.mq.min.tablet} {
          padding: 0;
          transform: rotate(0deg);
          display: flex;
          align-items: center;
          flex-direction: column;
          top: 0;
          left: 0;
        }
      }
      .toolbar__buttons {
        display: flex;
        flex-direction: row-reverse;
        width: 100%;
        height: 100%;
        @media ${theme.mq.min.tablet} {
          padding: 0.25em;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          > *:not(:last-child) {
            margin-top: 0.0675em;
            margin-bottom: 0.0675em;
          }
        }
      }
      [data-toolbar='TopLeft'],
      [data-toolbar='CenterLeft'],
      [data-toolbar='TopRight'],
      [data-toolbar='CenterRight'] {
        @media ${theme.mq.max.tablet} {
          top: 1em;
          left: 1em;
        }
      }
      [data-toolbar='BottomLeft'],
      [data-toolbar='BottomRight'] {
        @media ${theme.mq.max.tablet} {
          bottom: 1em;
          left: 1em;
        }
      }
    `;
  }}
`;
